import { render } from "./ProviderTrainings.vue?vue&type=template&id=3d7c1fe9&scoped=true"
import script from "./ProviderTrainings.vue?vue&type=script&lang=js"
export * from "./ProviderTrainings.vue?vue&type=script&lang=js"

import "./ProviderTrainings.vue?vue&type=style&index=0&id=3d7c1fe9&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7c1fe9"]])

export default __exports__